import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-299c5a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buttons-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "video-controls" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "control-button-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "control-button disabled" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-tele-camera-flip" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "control-button-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "control-button disabled" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-tele-call" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "control-button-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "control-button disabled" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-tele-volume-up" })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventStateSpinner = _resolveComponent("EventStateSpinner")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_ContentWrapper = _resolveComponent("ContentWrapper")!

  return (_openBlock(), _createBlock(_component_ContentWrapper, { class: "content-wrapper" }, {
    "content-top": _withCtx(() => [
      _createElementVNode("div", {
        class: "waiting-room-overlay",
        style: _normalizeStyle(_ctx.getBackgroundImage)
      }, [
        _createVNode(_component_EventStateSpinner, {
          showFailureState: _ctx.showFailure,
          isLoading: _ctx.getIsLoading,
          loadingIcon: "icon-tele-doc",
          loadingTitle: this.$mhat('WaitingRoomOverlay.LoadingTitle'),
          loadingMessage: _ctx.getLoadingMessages,
          successIcon: "icon-tele-doc",
          successTitle: this.$mhat('WaitingRoomOverlay.AppointmentEndedMessage'),
          failureTitle: _ctx.failureOrDefault.title,
          failureMessage: _ctx.failureOrDefault.message,
          textColorLight: ""
        }, null, 8, ["showFailureState", "isLoading", "loadingTitle", "loadingMessage", "successTitle", "failureTitle", "failureMessage"]),
        _createElementVNode("div", _hoisted_1, [
          (_ctx.isLoading || _ctx.showFailureState)
            ? (_openBlock(), _createBlock(_component_BaseButton, {
                key: 0,
                pattern: _ctx.ButtonColorPattern.TRANSPARENT,
                color: _ctx.ButtonColor.PRIMARY,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('exit')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.$mhat("WaitingRoomOverlay.CloseButtonText")), 1)
                ]),
                _: 1
              }, 8, ["pattern", "color"]))
            : _createCommentVNode("", true),
          (!_ctx.isLoading && !_ctx.showFailureState)
            ? (_openBlock(), _createBlock(_component_BaseButton, {
                key: 1,
                pattern: _ctx.ButtonColorPattern.TRANSPARENT,
                color: _ctx.ButtonColor.PRIMARY,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onBackToHome()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.$mhat("WaitingRoomOverlay.HomePageButtonText")), 1)
                ]),
                _: 1
              }, 8, ["pattern", "color"]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_2
      ], 4)
    ]),
    _: 1
  }))
}